<ng-template let-extraClass="extraClass" #topNav>
  @if (!windowService?.isDesktopRes) {
    <tidy-top-nav
      [class]="extraClass"
      [title]="'Checklists'"
      [canGoBack]="true"
      [customBack]="fromGettingStarted ? 'getting-started' : null" />
  }
</ng-template>

<ng-container *ngTemplateOutlet="topNav;context:{ extraClass: 'mobile' }" />

<ng-template #content>
  <tidy-wrapper>
    @if (!loaded) {
      <div class="loading-container">
        <tidy-loader />
      </div>
    }
    @if (loaded) {
      <form [formGroup]="itemForm" novalidate action="#">
        <div class="wizard-progress-bar">
          <div class="wizard-progress-fill" [style.width.%]="progressPercent"></div>
        </div>

        @if (currentStep === 1) {
          <div class="wizard-step-header">
            <tidy-text [title]="'Do you have existing checklists for cleaning / turnovers / other jobs?'" />
          </div>

          <div class="wizard-cards">
            <tidy-card
              class="wizard-card"
              (click)="selectMethod('yes')">
              <div class="wizard-card-radio">
                  <span class="wizard-card-radio-inner"></span>
                </div>
              <div class="wizard-card-text">
                <tidy-text [body]="'Yes'" />
                <tidy-text [helper]="'I have checklists I\'d like to upload.'" />
              </div>
            </tidy-card>

            <tidy-card
              class="wizard-card"
              (click)="selectMethod('no')">
              <div class="wizard-card-radio">
                  <span class="wizard-card-radio-inner"></span>
                </div>
              <div class="wizard-card-text">
                <tidy-text [body]="'No'" />
                <tidy-text [helper]="'I\'d like to start from a template.'" />
              </div>
            </tidy-card>
          </div>
        }

        @if (currentStep === 2) {
          @if (itemForm.value.method === 'yes') {
            <div class="wizard-step-header">
              <tidy-text [title]="'Upload Checklists'" />
            </div>
            <tidy-card class="wizard-content">
              <tidy-row>
                <tidy-pill-button
                  [image]="'assets/svg/cloud-upload-outline.svg'"
                  [text]="'Upload Checklist'"
                  (buttonClick)="addAttachment()" />
              </tidy-row>
              <tidy-row>
                <tidy-text
                  [helper]="'We can handle one or multiple files of any type.'" />
              </tidy-row>
              @if (attachments.length) {
                <tidy-row class="extra-top-padding extra-bottom-padding">
                  @for (attachment of attachments; track attachment.fileKey; let i = $index) {
                    <tidy-row>
                      <tidy-text
                        [body]="attachment.filename" /><span>&nbsp;</span>
                      <tidy-text
                        [actionBody]="'remove'"
                        (action)="removeAttachment(i)"
                        class="red link" />
                    </tidy-row>
                  }
                </tidy-row>
              }
            </tidy-card>
            <div class="wizard-nav-row wizard-content">
              <tidy-button
                [text]="'Next'"
                [action]="goToNextStep"
                class="primary" />
            </div>
          }

          @if (itemForm.value.method === 'no') {
            <div class="wizard-step-header">
              <tidy-text [title]="'Start With a Template (Optional)'" />
            </div>

            <div class="wizard-cards">
              @for (template of templates; track template.value) {
                <tidy-card
                  class="wizard-card"
                  (click)="selectTemplate(template.value)">
                  <div class="wizard-card-radio">
                  <span class="wizard-card-radio-inner"></span>
                </div>
                  <div class="wizard-card-text">
                    <tidy-text [body]="template.viewValue" />
                    @if (template.extraText) {
                      <tidy-text [helper]="template.extraText" />
                    }
                  </div>
                </tidy-card>
              }
            </div>

            <div class="wizard-nav-row wizard-content">
              <tidy-button
                [text]="'Next'"
                [action]="goToNextStep"
                class="primary" />
            </div>
          }
        }

        @if (currentStep === 3) {
          <div class="wizard-step-header">
            <tidy-text [title]="'Notes for Concierge (Optional)'" />
          </div>
          <div class="wizard-content">
            <tidy-row>
              <tidy-textarea
                [label]="'Anything we should know about your checklists?'"
                [icon]="'assets/svg/create.svg'"
                [submitted]="submitted"
                [errorMessage]="'Please enter a description'"
                [form]="itemForm.controls.body"
                formControlName="body" />
            </tidy-row>

            <div class="wizard-nav-row">
              <tidy-button
                [text]="'Finish'"
                [action]="finish"
                class="primary" />
            </div>
          </div>
        }
      </form>

      @if (isCreating) {
        <div class="loading-overlay">
          <div class="loading-overlay-content">
            <ion-spinner name="crescent" class="loading-spinner" />
            <tidy-text [header]="'Creating checklist...'" class="loading-text" />
          </div>
        </div>
      }
    }
  </tidy-wrapper>
</ng-template>

@if (!windowService?.isDesktopRes) {
  <app-scroll-wrapper [templateContent]="content" />
} @else {
  <ng-container *ngTemplateOutlet="content" />
}
